<div class="flex flex-col items-center justify-center">
    <div class="w-full flex items-center justify-end">
        <button (click)="onDismiss()" class="w-6 h-6 rounded-md bg-gray-100">
            <i class="fas fa-times text-sm text-gray-500"></i>
        </button>
    </div>
    <p class="text-sm font-display text-gray-700 font-medium">Dokumen Laporan yang Diunggah</p>
    <div class="w-full grid grid-cols-2 gap-4 mt-4">
        <div *ngFor="let data of data" class="w-full flex items-center rounded-md border border-gray-200 bg-white p-2">
            <a [href]="helper.parseRelPath(data.file?.rel_path)" [download]="data.file?.filename" class="text-sm text-gray-700">{{data.file?.filename}}</a>
        </div>
    </div>
</div>